"use strict";

exports.__esModule = true;
exports.DeviceConnectionStatusContext = void 0;
var _DeviceStatusController = require("../DeviceStatusController/DeviceStatusController");
var _Utils = require("../../../../Utils");
/**
 * Provides Device Connection Status Context to consumers
 * @component
 */
var DeviceConnectionStatusContext = exports.DeviceConnectionStatusContext = (0, _Utils.createEnhancedContext)({
  propName: "connection",
  defaultController: _DeviceStatusController.DeviceStatusController
});